import { Box } from '@ff-it/ui';
import { PlanRow } from 'modules/campaign/row';
import { ProductName } from 'modules/supplier/products';
import { SupplierTitle } from 'modules/supplier/supplier/components';
import { ReactElement } from 'react';
import { commentContainer } from './ViewSupplier.css';

export function ViewSupplier({ row }: { row: PlanRow }): ReactElement {
  const supplier = row.supplier;

  return (
    <Box flexGrow={1} display="flex" flexDirection="column" minWidth="0" lineHeight="1">
      {supplier ? (
        <SupplierTitle flexGrow={1} minWidth="0" {...supplier} customProductName={row.product_name || undefined} />
      ) : row.product_name ? (
        <ProductName customProductName={row.product_name} />
      ) : null}

      {row.comment && (
        <div data-testid="comment" className={commentContainer} title={row.comment}>
          {row.comment}
        </div>
      )}
    </Box>
  );
}
